import { ConditionSide, InsoleType, ProfileCurveTemplates } from "./Insole";


export class AutoProperties {
    heelDepthLeftY: number = 19.065;
    heelDepthRightY: number = 19.065;

    insoleTemplate: InsoleType = InsoleType.Standard;
    profileCurveRight: ProfileCurveTemplates = ProfileCurveTemplates.Generic;
    profileCurveLeft: ProfileCurveTemplates = ProfileCurveTemplates.Generic;

    metatarsalgia: ConditionSide = ConditionSide.none;
    halluxLimitus: ConditionSide = ConditionSide.none;
    sesamoiditis: ConditionSide = ConditionSide.none;

    offLoadingCutout: boolean = false;
    limbLengthDiscrepancy: boolean = false;
    shorterLimb: 'right' | 'left' = 'right';
    DiscrepancyAmount: number = 10;

    metatarSalBarLeft: number = -1;
    metatarSalBarRight: number = -1;
    metatarSalPadLeft: number = -1;
    metatarSalPadRight: number = -1;
    mortonsExtensionLeft: number = -1;
    mortonsExtensionRight: number = -1;
    dancersPadLeft: number = -1;
    dancersPadRight: number = -1;

    cutoutMet1Left: number = -1;
    cutoutMet1Right: number = -1;
    cutoutMet2Left: number = -1;
    cutoutMet2Right: number = -1;
    cutoutMet3Left: number = -1;
    cutoutMet3Right: number = -1;
    cutoutMet4Left: number = -1;
    cutoutMet4Right: number = -1;
    cutoutMet5Left: number = -1;
    cutoutMet5Right: number = -1;

    thirdQuarter: boolean = false;

    constructor(init?: Partial<AutoProperties>) {
        if (init) Object.assign(this, init);
    }

    static cloneFrom(original: AutoProperties): AutoProperties {
        const copy = new AutoProperties();

        copy.heelDepthLeftY = original.heelDepthLeftY;
        copy.heelDepthRightY = original.heelDepthRightY;
        copy.insoleTemplate = original.insoleTemplate;
        // copy.profileCurveType = original.profileCurveType;
        copy.profileCurveRight = original.profileCurveRight;
        copy.profileCurveLeft = original.profileCurveLeft;
        copy.metatarsalgia = original.metatarsalgia;
        copy.halluxLimitus = original.halluxLimitus;
        copy.sesamoiditis = original.sesamoiditis;

        copy.offLoadingCutout = original.offLoadingCutout;
        copy.limbLengthDiscrepancy = original.limbLengthDiscrepancy;
        copy.shorterLimb = original.shorterLimb;
        copy.DiscrepancyAmount = original.DiscrepancyAmount;

        copy.metatarSalBarLeft = original.metatarSalBarLeft;
        copy.metatarSalBarRight = original.metatarSalBarRight;
        copy.metatarSalPadLeft = original.metatarSalPadLeft;
        copy.metatarSalPadRight = original.metatarSalPadRight;
        copy.mortonsExtensionLeft = original.mortonsExtensionLeft;
        copy.mortonsExtensionRight = original.mortonsExtensionRight;
        copy.dancersPadLeft = original.dancersPadLeft;
        copy.dancersPadRight = original.dancersPadRight;

        copy.cutoutMet1Left = original.cutoutMet1Left;
        copy.cutoutMet1Right = original.cutoutMet1Right;
        copy.cutoutMet2Left = original.cutoutMet2Left;
        copy.cutoutMet2Right = original.cutoutMet2Right;
        copy.cutoutMet3Left = original.cutoutMet3Left;
        copy.cutoutMet3Right = original.cutoutMet3Right;
        copy.cutoutMet4Left = original.cutoutMet4Left;
        copy.cutoutMet4Right = original.cutoutMet4Right;
        copy.cutoutMet5Left = original.cutoutMet5Left;
        copy.cutoutMet5Right = original.cutoutMet5Right;

        copy.thirdQuarter = original.thirdQuarter;

        return copy;
    }

    loadFromDTO(dto: AutoPropertiesDTO) {
        this.heelDepthLeftY = dto.heelDepthLeftY;
        this.heelDepthRightY = dto.heelDepthRightY;
        this.insoleTemplate = dto.insoleTemplateRight;
        this.profileCurveRight = dto.profileCurveRight;
        this.profileCurveLeft = dto.profileCurveLeft;

        if (dto.metatarsalgia === null) this.metatarsalgia = ConditionSide.none;
        else this.metatarsalgia = dto.metatarsalgia;
        if (dto.halluxLimitus === null) this.halluxLimitus = ConditionSide.none;
        else this.halluxLimitus = dto.halluxLimitus;
        if (dto.sesamoiditis === null) this.sesamoiditis = ConditionSide.none;
        else this.sesamoiditis = dto.sesamoiditis;

        if (dto.lengthDiscrepancyAmount === null) this.limbLengthDiscrepancy = false;
        else if (dto.lengthDiscrepancyAmount > 0) {
            this.shorterLimb = 'right';
            this.DiscrepancyAmount = Math.abs(dto.lengthDiscrepancyAmount);
            this.limbLengthDiscrepancy = true;
        }
        else if (dto.lengthDiscrepancyAmount < 0) {
            this.shorterLimb = 'left';
            this.DiscrepancyAmount = Math.abs(dto.lengthDiscrepancyAmount);
            this.limbLengthDiscrepancy = true;
        }
        else this.limbLengthDiscrepancy = false;

        if (dto.metatarSalBarLeft === null) { this.metatarSalBarLeft = -1; }
        else { this.metatarSalBarLeft = dto.metatarSalBarLeft; }

        if (dto.metatarSalBarRight === null) { this.metatarSalBarRight = -1; }
        else { this.metatarSalBarRight = dto.metatarSalBarRight; }

        if (dto.metatarSalPadLeft === null) { this.metatarSalPadLeft = -1; }
        else { this.metatarSalPadLeft = dto.metatarSalPadLeft; }

        if (dto.metatarSalPadRight === null) { this.metatarSalPadRight = -1; }
        else { this.metatarSalPadRight = dto.metatarSalPadRight; }

        if (dto.mortonsExtensionLeft === null) { this.mortonsExtensionLeft = -1; }
        else { this.mortonsExtensionLeft = dto.mortonsExtensionLeft; }

        if (dto.mortonsExtensionRight === null) { this.mortonsExtensionRight = -1; }
        else { this.mortonsExtensionRight = dto.mortonsExtensionRight; }

        if (dto.dancersPadLeft === null) { this.dancersPadLeft = -1; }
        else { this.dancersPadLeft = dto.dancersPadLeft; }

        if (dto.dancersPadRight === null) { this.dancersPadRight = -1; }
        else { this.dancersPadRight = dto.dancersPadRight; }

        if (dto.cutoutMet1Left === null) { this.cutoutMet1Left = -1; }
        else { this.cutoutMet1Left = dto.cutoutMet1Left; }

        if (dto.cutoutMet1Right === null) this.cutoutMet1Right = -1;
        else this.cutoutMet1Right = dto.cutoutMet1Right;

        if (dto.cutoutMet2Left === null) { this.cutoutMet2Left = -1; }
        else { this.cutoutMet2Left = dto.cutoutMet2Left; }

        if (dto.cutoutMet2Right === null) this.cutoutMet2Right = -1;
        else this.cutoutMet2Right = dto.cutoutMet2Right;

        if (dto.cutoutMet3Left === null) { this.cutoutMet3Left = -1; }
        else { this.cutoutMet3Left = dto.cutoutMet3Left; }

        if (dto.cutoutMet3Right === null) this.cutoutMet3Right = -1;
        else this.cutoutMet3Right = dto.cutoutMet3Right;


        if (dto.cutoutMet4Left === null) { this.cutoutMet4Left = -1; }
        else { this.cutoutMet4Left = dto.cutoutMet4Left; }

        if (dto.cutoutMet4Right === null) this.cutoutMet4Right = -1;
        else this.cutoutMet4Right = dto.cutoutMet4Right;

        if (dto.cutoutMet5Left === null) { this.cutoutMet5Left = -1; }
        else { this.cutoutMet5Left = dto.cutoutMet5Left; }

        if (dto.cutoutMet5Right === null) this.cutoutMet5Right = -1;
        else this.cutoutMet5Right = dto.cutoutMet5Right;

        if (this.cutoutMet1Left !== -1 || this.cutoutMet1Right != -1 || this.cutoutMet2Left != -1 || this.cutoutMet2Right != -1 || this.cutoutMet3Left != -1 || this.cutoutMet3Right != -1 ||
            this.cutoutMet4Left != -1 || this.cutoutMet4Right != -1 || this.cutoutMet5Left != -1 || this.cutoutMet5Right != -1)
            this.offLoadingCutout = true;
        else this.offLoadingCutout = false;

        this.thirdQuarter = dto.thirdQuarter;
    }

    saveToDto(): AutoPropertiesDTO {
        let dto = new AutoPropertiesDTO();
        dto.heelDepthLeftY = this.heelDepthLeftY;
        dto.heelDepthRightY = this.heelDepthRightY;
        dto.insoleTemplateRight = this.insoleTemplate;
        dto.insoleTemplateLeft = this.insoleTemplate;
        dto.profileCurveRight = this.profileCurveRight;
        dto.profileCurveLeft = this.profileCurveLeft;
        dto.metatarsalgia = this.metatarsalgia;
        dto.halluxLimitus = this.halluxLimitus;
        dto.sesamoiditis = this.sesamoiditis;
        dto.metatarSalBarLeft = this.metatarSalBarLeft;
        dto.metatarSalBarRight = this.metatarSalBarRight;
        dto.metatarSalPadLeft = this.metatarSalPadLeft;
        dto.metatarSalPadRight = this.metatarSalPadRight;
        dto.mortonsExtensionLeft = this.mortonsExtensionLeft;
        dto.mortonsExtensionRight = this.mortonsExtensionRight;
        dto.dancersPadLeft = this.dancersPadLeft;
        dto.dancersPadRight = this.dancersPadRight;
        dto.cutoutMet1Left = this.cutoutMet1Left;
        dto.cutoutMet1Right = this.cutoutMet1Right;
        dto.cutoutMet2Left = this.cutoutMet2Left;
        dto.cutoutMet2Right = this.cutoutMet2Right;
        dto.cutoutMet3Left = this.cutoutMet3Left;
        dto.cutoutMet3Right = this.cutoutMet3Right;
        dto.cutoutMet4Left = this.cutoutMet4Left;
        dto.cutoutMet4Right = this.cutoutMet4Right;
        dto.cutoutMet5Left = this.cutoutMet5Left;
        dto.cutoutMet5Right = this.cutoutMet5Right;
        dto.thirdQuarter = this.thirdQuarter;

        if (this.limbLengthDiscrepancy) {
            if (this.shorterLimb == 'right') dto.lengthDiscrepancyAmount = this.DiscrepancyAmount;
            else if (this.shorterLimb == 'left') dto.lengthDiscrepancyAmount = this.DiscrepancyAmount * -1;
        } else {
            dto.lengthDiscrepancyAmount = null;
        }

        return dto;
    }
}

export class AutoPropertiesDTO {
    insoleTemplateRight: InsoleType = InsoleType.Standard;
    insoleTemplateLeft: InsoleType = InsoleType.Standard;
    profileCurveRight: ProfileCurveTemplates = ProfileCurveTemplates.Generic;
    profileCurveLeft: ProfileCurveTemplates = ProfileCurveTemplates.Generic;

    metatarsalgia: ConditionSide | null = null;
    halluxLimitus: ConditionSide | null = null;
    sesamoiditis: ConditionSide | null = null;
    heelSpur: ConditionSide | null = null;
    diabetic: ConditionSide | null = null;

    archIndexRight: number = -1;
    archIndexLeft: number = -1;
    heelDepthLeftY: number = 0;
    heelDepthRightY: number = 0;

    lengthDiscrepancyAmount: number | null = null;

    metatarSalBarLeft: number | null = null;
    metatarSalBarRight: number | null = null;
    metatarSalPadLeft: number | null = null;
    metatarSalPadRight: number | null = null;
    mortonsExtensionLeft: number | null = null;
    mortonsExtensionRight: number | null = null;
    dancersPadLeft: number | null = null;
    dancersPadRight: number | null = null;
    cutoutMet1Left: number | null = null;
    cutoutMet1Right: number | null = null;
    cutoutMet2Left: number | null = null;
    cutoutMet2Right: number | null = null;
    cutoutMet3Left: number | null = null;
    cutoutMet3Right: number | null = null;
    cutoutMet4Left: number | null = null;
    cutoutMet4Right: number | null = null;
    cutoutMet5Left: number | null = null;
    cutoutMet5Right: number | null = null;

    thirdQuarter: boolean = false;

    constructor(init?: Partial<AutoPropertiesDTO>) {
        if (init) Object.assign(this, init);
    }

    private static readonly propertyKeys: (keyof AutoPropertiesDTO)[] = [
        "insoleTemplateRight",
        "insoleTemplateLeft",
        "profileCurveLeft",
        "profileCurveRight",
        "profileCurveLeft",
        "metatarsalgia",
        "halluxLimitus",
        "sesamoiditis",
        "heelSpur",
        "diabetic",
        "archIndexRight",
        "archIndexLeft",
        "lengthDiscrepancyAmount",
        "metatarSalBarLeft",
        "metatarSalBarRight",
        "metatarSalPadLeft",
        "metatarSalPadRight",
        "mortonsExtensionLeft",
        "mortonsExtensionRight",
        "dancersPadLeft",
        "dancersPadRight",
        "cutoutMet1Left",
        "cutoutMet1Right",
        "cutoutMet2Left",
        "cutoutMet2Right",
        "cutoutMet3Left",
        "cutoutMet3Right",
        "cutoutMet4Left",
        "cutoutMet4Right",
        "cutoutMet5Left",
        "cutoutMet5Right",
        "heelDepthLeftY",
        "heelDepthRightY",
        "thirdQuarter"
    ];

    loadFromJson(json: any): this {
        if (!json || typeof json !== "object") return this;

        for (const key of AutoPropertiesDTO.propertyKeys) {
            if (key in json) {
                this[key] = json[key];
            }
        }
        return this;
    }

    saveToJson(): any {
        const json: any = {};
        for (const key of AutoPropertiesDTO.propertyKeys) {
            const value = this[key];
            if (value !== null && value !== undefined) {
                json[key] = value;
            }
        }
        return json;
    }


    static fromJson(json: any): AutoPropertiesDTO {
        return new AutoPropertiesDTO().loadFromJson(json);
    }

}
